export default {
  //教学课程
  courseList: '',
  courseInfo: {
    names: '',
    natures: '',
    cover: '',
    add: '',
    course: ',',
    group: "",
    permission: '',
    del: ''
  },
  courseChapter: {
    root: '',
    child: '',
    add: ''
  },
  courseChapterRes: {
    add: '',
    library: '',
    student: ''
  },
  systemList: {
    majorList: {}
  },
  courseMenuList: {},
  courseMaterialInfo: {},

  SKcourseList: '',
  SKopenpad:'',
  courseClose: {},
  courseImport:'',
  courseResource:[]
}
